import BaseDialog from '@material-ui/core/Dialog';
import styled, { DefaultTheme } from 'styled-components';

const mapColors = ({ theme }: { theme: DefaultTheme }) =>
  theme.type === 'light'
    ? {
        $progress: theme.colors.black[900],
        $bg: theme.colors.white[1000],
        $color: theme.colors.black[900],
      }
    : {
        $bg: theme.colors.black[900],
        $color: theme.colors.white[1000],
        $progress: theme.colors.white[900],
      };

export const ContentContainer = styled.div`
  padding: 2rem 1rem;
`;

export const Description = styled.p.attrs(mapColors)`
  text-align: left;
  font-size: 2rem;
  margin: 1rem 2rem;
  font-weight: normal;
  color: ${(p) => p.$color};
`;

export const BoldTitle = styled.span`
  font-weight: 500;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
`;
export const AttachColumn = styled.div`
  display: flex;
  flex-direction: column;
  font-weight: 500;
  margin-top: 20px;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  font-weight: 500;
`;

export const Buttons = styled.div`
  padding: 10px 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  & .MuiButtonBase-root {
    margin-left: 10px;
  }
`;

export const ProgressText = styled.p.attrs(mapColors)`
  font-size: 1.8rem;
  padding: 0 20px;
  margin: 10px 0;
`;

export const Dialog = styled(BaseDialog).attrs(mapColors)`
  & .MuiLinearProgress-root {
    margin: 10px 20px;
    margin-top: 5px;
    height: 15px;
    border-radius: 4px;
  }
  & .MuiDialog-paperWidthSm {
    max-width: ${(p) => p.theme.maxWidthNumber - 40}px;
  }
  & .MuiPaper-root {
    background-color: ${(p) => p.$bg};
    color: ${(p) => p.$color};
  }
`;

export const Image = styled.img`
  border-radius: 5px;
  width: 142px;
  height: 140px;
  cursor: pointer;
`;
